import { useEffect, useRef } from 'react';
import { useAppActions } from '@afosto/app-components-react/AppProvider';
import mergeWith from 'lodash.mergewith';
import { profile as profileApi } from '@afosto/iam/api/Profile';

export default (path, defaultSettings = {}) => {
  const [actions] = useAppActions();
  const actionsRef = useRef(actions);
  const defaultSettingsRef = useRef(defaultSettings);

  useEffect(() => {
    actionsRef.current = actions;
    defaultSettingsRef.current = defaultSettings;
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await profileApi.getProfile(`afosto.tenant.${path}.v1.settings`);
        const { data = {} } = response;

        actionsRef.current.setSettings(mergeWith(defaultSettingsRef.current ?? {}, data));
      } catch (err) {
        // Do nothing.
      }
    };

    fetchSettings();
  }, [path]);
};
